var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-root header-background",class:{
        overlap: _vm.overlap === 'small',
        overlapLarge: _vm.overlap === 'large',
        small: _vm.size === 'small',
        medium: _vm.size === 'medium',
        large: _vm.size === 'large',
        disableOverlay: !_vm.overlay,
    },style:(_vm.styles)},[_c('div',{staticClass:"header-content",class:{
            'mw-medium': _vm.maxWidth === 'medium',
            'mw-large': _vm.maxWidth === 'large',
        }},[(!_vm.disableTitle)?_c('h2',{staticClass:"header inherit-color"},[_vm._v(_vm._s(_vm.label || _vm.fullName))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }